import React, { useEffect, useState} from 'react'
import { Steps, Input, Select, Form, Button, Checkbox, message, Card, Tabs } from 'antd'
import { ajaxApi,getMethod } from '@/server/index'
import _lodash,{get} from 'lodash'
import common from '@/public/common'
import { transferSelectKeys } from '@/public/utils'
import style from './../index.module.less'
import {setCookieNew} from '@/public/utils'
import {CheckCircleFilled} from '@ant-design/icons'
import {md5hex} from '@/public/utils'
const { Step } = Steps
const FormItem = Form.Item
const Option = Select.Option
const CheckboxGroup = Checkbox.Group
const { TabPane } = Tabs
const SupplierRegistration = () => {
  const [current, setcurrent] = useState(0)
  const [paramData, setParamData] = useState({ /** 注意：此处手机号和邮箱字段共用，具体可以找吴康咨询 */
    phone: '',
    password: '',
    verify_code: '',
    credit_code: '',
    supplier_name: '',
    pro_category: '',
    email: ''
  })

  const [disabledstatus, setdisabledstatus] = useState(false)
  const [btnText, setbtnText] = useState('获取验证码')
  const [sid, setsid] = useState(null)
  const [passwordConfirm, setpasswordConfirm] = useState('')
  const [is_hava_account, setis_hava_account] = useState(false)
  const [activetab, setActivetab] = useState('1')
  const numberAreaCode = [{
    label: '中国大陆 + 86',
    value: 86
  }
  // {
  //   label: '中国台湾 + 886',
  //   value: '886'
  // }, {
  //   label: '中国香港 + 852',
  //   value: '852'
  // }, {
  //   label: '韩国 + 82',
  //   value: '82'
  // }
  ]
const [plainOptions,setplainOptions] = useState([])

  useEffect(()=>{
    getDicitionary()
  },[])

  const getDicitionary=async()=>{
    try{
      let res = await getMethod(common.scpUrl + 'supplier-enter/supplier/collection/conditions')
      setplainOptions(transferSelectKeys(get(res,'data.data.pro_category_dict')||[]))
    }catch(err){console.log(err)}
  }

  const handleCkeckBox = (e, name) => {
    setParamData({...paramData, [name]: e})
  }

  // 公共校验方法：校验手机号/邮箱格式
  const validateAccountFormat = (value) => {
    var emailreg = /^[A-Za-z0-9一-龥]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
    var phone = /^1(?:3\d|4[4-9]|5[0-35-9]|6[67]|7[013-8]|8\d|9\d)\d{8}$/
    if (activetab == 1) {
      if (!phone.test(value)) {
        message.error('请输入正确的手机号！')
        return false
      }
    } else {
      if (!emailreg.test(value)) {
        message.error('请输入正确的邮箱！')
        return false
      }
    }
    return true
  }

  // 倒计时60秒
  const handleCountDown = (seconds) => {
    let second = seconds
    const countDown = () => {
      if (second > 0) {
        second--
        const codeText = '倒计时' + '(' + second + ')'
        setbtnText(codeText)
        setdisabledstatus(true)
      }
      if (second === 0) {
        second = 60
        setbtnText('获取验证码')
        setdisabledstatus(false)
        return
      }
      setTimeout(countDown, 1000)
    }
    setTimeout(countDown, 1000)
  }

  // 获取验证码
  const handleVerificationCode = async () => {
    if (is_hava_account) {
      message.error('当前账号已注册，请确认后再操作！')
      return false
    }
    const paramDataClone = JSON.parse(JSON.stringify(paramData))
    const postData = {
      message_tmp: '',
      phone_no: paramDataClone.phone,
      verify_type: activetab == 1 ? 'phone' : 'email'
    }
    if (paramDataClone.phone === '') {
      message.warning('请填写' + (activetab == 1 ? '手机' : '邮箱') + '号码', 2)
      return false
    }

    // 校验手机号/邮箱格式
    if (!validateAccountFormat(paramDataClone.phone)) {
      return false
    }
    try {
      const res = await ajaxApi({
        url: common.SapUrl + 'base/getVerificationCode',
        params: postData
      })

      if (res.status === 200) {
        handleCountDown(60)
      }
    } catch (err) {
      return null
    }
  }

  // 下一步
  const handleNext = async () => {
    let currentNew = JSON.parse(JSON.stringify(current))
    try {
      if (currentNew === 0) {
        if (!paramData.phone || !paramData.verify_code || !paramData.password || !passwordConfirm) {
          message.warning('请填写' + (activetab == 1 ? '手机' : '邮箱') + '号码、验证码、密码')
          return false
        }
        var regu = '^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,20}$'
        var re = new RegExp(regu)
        if (!re.test(paramData.password)) {
          message.error('密码由6-16位字母数字组合，区分大小写!')
          return false
        }

        if (paramData.password !== passwordConfirm) {
          message.warning('确认密码错误')
          return false
        }
        if (paramData.verify_code.toString().length < 3) {
          message.warning('验证码密码验大于或等于4位数字')
          return false
        }
        try {
          // const respon = await ajaxApi({
          //   url: common.scpUrl + '/base/checkVerificationCode',
          //   params: {
          //     phone_no: paramData.phone,
          //     verification_code: paramData.verify_code
          //   }
          // })
          // console.log(respon)
          // if (respon.status !== 200) {
          //   return false
          // }
        } catch (err) {
          return false
        }
      }
      if (currentNew === 1) {
        if (!paramData.email && activetab == 1) {
          message.error('请填写企业邮箱!')
          return false
        }
      }
       const paramDataClone = JSON.parse(JSON.stringify(paramData))
        paramDataClone.password = md5hex(paramDataClone.password.toString())
        setParamData({...paramData, phone: paramDataClone.phone})
        const res = await ajaxApi({
          url: common.eurekaUrlDic + '/account/register-supplier',
          params: {...paramDataClone, 'register_type': activetab == 1 ? 'phone' : 'email'}
        })
        if (res.status === 200) {
          setCookieNew('accountId',res.data.account_id , 3)
          setsid(res.data.sid)
        } else {
          setcurrent(0)
        }
      currentNew = current + 1
      setcurrent(currentNew)
    } catch (err) {
      console.log(err)
      setcurrent(0)
    }
  }
  // tabs切换
  const tabsChange = (e) => {
    setActivetab(e)
    setParamData({
      phone: '',
      password: '',
      verify_code: '',
      credit_code: '',
      supplier_name: '',
      pro_category: '',
      email: ''
    })
  }
  // 当前帐号是否已经被注册
  const isCanUse = async (e) => {
    if (!e.target.value) {
      message.error((activetab == 1 ? '手机号' : '邮箱') + '不能为空！')
      return false
    }
    // 校验手机号/邮箱格式
    if (!validateAccountFormat(e.target.value)) {
      return false
    }
    const {data} = await ajaxApi({
      url: common.eurekaUrlDic + '/account/judge-account',
      params: {
        'account': e.target.value
      }
    })
    console.log(data)
    if (data) {
      setis_hava_account(data.is_hava_account == 1)
      if (data.is_hava_account == 1) {
        message.error('当前帐号已被注册！')
        return false
      }
    } else {

    }
  }
  const domFunc = () => {
    if (current === 0) {
      return (
        <Tabs activeKey={activetab} centered onChange={tabsChange}>
          <TabPane tab={<div style={{padding: '0 70px'}}>手机号注册</div>} key="1">
            <FormItem>
              <span className={style.public_span}><span style={{color: 'red'}}>*</span>手机号码：</span>
              <Select
                showSearch
                // mode="multiple"
                style={{ width: 148, marginRight: '4px' }}
                optionFilterProp="children"
                placeholder='请选择'
                disabled
                value={86}
              >
                {numberAreaCode.map((item, index) => (
                  <Option key={index + 1} name='category_id' value={item.value}>{item.label}</Option>
                )) }
              </Select>
              <Input placeholder='请输入' name='phone' maxLength={11} value={paramData.phone} onBlur={isCanUse} onChange={(e) => { setParamData({...paramData, phone: e.target.value.replace(/\D/g, '')}) }} style={{ width: 198, marginRight: '0px' }} />
            </FormItem>
            <FormItem>
              <span className={style.public_span}><span style={{color: 'red'}}>*</span>短信验证：</span>
              <Input placeholder='请输入验证码' minLength={2} disabled ={!paramData.phone} value={paramData.verify_code} onChange={(e) => { setParamData({...paramData, verify_code: e.target.value.replace(/\D/g, '')}) }} basicInformationData style={{ width: 240, marginRight: '8px' }} />
              <Button type="primary" id ='btnDom' disabled={disabledstatus} onClick={handleVerificationCode}>{btnText}</Button>
            </FormItem>

            <FormItem>
              <span className={style.public_span}><span style={{color: 'red'}}>*</span>输入密码：</span>
              <Input.Password placeholder='密码由6-16位字母数字组合，区分大小写' value={paramData.password} onChange={(e) => { setParamData({...paramData, password: e.target.value}) }} basicInformationData style={{ width: 348, marginRight: '0px' }} />
            </FormItem>

            <FormItem>
              <span className={style.public_span}><span style={{color: 'red'}}>*</span>确认密码：</span>
              <Input.Password controls={false} placeholder='请输入' value={passwordConfirm} onChange={(e) => { setpasswordConfirm(e.target.value) }} basicInformationData style={{ width: 348, marginRight: '0px' }} />
            </FormItem>
          </TabPane>
          <TabPane tab={<div style={{padding: '0 20px'}}>邮箱注册（国外企业推荐）</div>} key="2">
            <FormItem >
              <span className={style.public_span}><span style={{color: 'red'}}>*</span>邮箱：</span>
              <Input placeholder='请输入邮箱地址' name='phone' onBlur={isCanUse} value={paramData.phone} onChange={(e) => { setParamData({...paramData, phone: e.target.value}) }} style={{ width: 348, marginRight: '0px' }} />
            </FormItem>
            <FormItem>
              <span className={style.public_span}><span style={{color: 'red'}}>*</span>验证码：</span>
              <Input placeholder='请输入验证码' minLength={2} disabled ={!paramData.phone} value={paramData.verify_code} onChange={(e) => { setParamData({...paramData, verify_code: e.target.value.replace(/\D/g, '')}) }} basicInformationData style={{ width: 240, marginRight: '8px' }} />
              <Button type="primary" id ='btnDom' disabled={disabledstatus} onClick={handleVerificationCode}>{btnText}</Button>
            </FormItem>

            <FormItem>
              <span className={style.public_span}><span style={{color: 'red'}}>*</span>输入密码：</span>
              <Input.Password placeholder='密码由6-16位字母数字组合，区分大小写' value={paramData.password} onChange={(e) => { setParamData({...paramData, password: e.target.value}) }} basicInformationData style={{ width: 348, marginRight: '0px' }} />
            </FormItem>

            <FormItem>
              <span className={style.public_span}><span style={{color: 'red'}}>*</span>确认密码：</span>
              <Input.Password controls={false} placeholder='请输入' value={passwordConfirm} onChange={(e) => { setpasswordConfirm(e.target.value) }} basicInformationData style={{ width: 348, marginRight: '0px' }} />
            </FormItem>
          </TabPane>
        </Tabs>
      )
    }
    if (current === 1) {
      return (
        <span>
          <FormItem><CheckCircleFilled style={{color: 'limegreen', fontSize: '60px'}} /><div style={{marginTop: '24PX'}}>你的账户提交成功</div></FormItem>
          <FormItem>
            <span style={{fontSize: '22px', fontWeight: 900}}>账号：</span><span style={{color: 'limegreen'}}>{ paramData.phone || '**************'}</span>
            <div style={{display: 'none'}}>账号以及密码已发往企业邮箱，请注意查收</div>
          </FormItem>
          <FormItem><Button type="primary" onClick ={() => { window.open('/main/suppliersettlement/supplierinformationentry/new-supplier-information-entry?opration=perfection') }}>立即登录</Button></FormItem>
        </span>
      )
    }
  }

  return (
    <Card style={{width: '800px', textAlign: 'center', margin: '100px auto'}}>
      <div style={{width: '700px', textAlign: 'center', margin: '0 auto'}}>
        <div style={{fontSize: '32px', fontWeight: 600, margin: '24px 0px', textAlign: current === 2 ? 'center' : 'left'}}> 供应商注册</div>
        <div style={{width: '700px', margin: '0px auto'}}>
          <Steps current={current}>
            <Step title="填写账号信息" description="" />
            <Step title="提交" description="" />
          </Steps>
        </div>

        <div style={{width: '700px', textAlign: current === 1 ? 'center' : 'left', marginTop: '24px'}}>{domFunc()}</div>
        <div style={{width: '700px', display: current === 1 ? 'none' : 'inline-block', textAlign: current === 1 ? 'center' : 'left', paddingLeft: '134px', marginBottom: '24px'}}>

          <Button onClick={handleNext} size="large" style={{width: '348px'}} type="primary">{current === 1 ? '提交' : '下一步'}</Button></div>
      </div>
    </Card>
  )
}
export default SupplierRegistration



// WEBPACK FOOTER //
// ./src/pages/suppliersettlement/supplierregistration/supplierregistration.js